module.exports = __webpack_public_path__ + "media/images/flags/4x3/nir-6da6aac98a06ddc786c6e702e6120907.svg";